import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';

@Component({
  selector: 'formly-field-ng-select2',
  template: `
<ng-select
  [items]="getOptions()"
  [formControl]="castFormControl()"
  [formlyAttributes]="field"
  [multiple]="props.multiple"
  [placeholder]="getPlaceholder()"
  (change)="props.change"
  [required]="getRequired()"
  [clearable]="getClearable()"
  [bindLabel]="getLabel()"
  [bindValue]="getValue()"
  [compareWith]="compareWith"
>
</ng-select>
  `,
})
/*
  [compareWith]="compareWith"
  [bindValue]="to.bindValue || 'value'"
 */
export class FormlyFieldNgSelect2 extends FieldType {

  private bindValueKey: string;
  protected bindValue: string;

  getLabel() {
    if (this.props.bindLabel) {
      return this.props.bindLabel;
    } // if
    return 'label';
  }

  getValue() {
    if (this.props.bindValue) {
      return this.props.bindValue;
    } // if
    return 'id';
  }

  getSelected() {
    return this.props.selected;
  }

  castFormControl(): any {
    return this.formControl;
  }

  getPlaceholder(): string {
    // Protect against undefined (?)
    if (this.props.placeholder) {
      return this.props.placeholder;
    }
    return '';
  }

  getRequired(): boolean {
    // Protect against undefined (?)
    if (this.props.required) {
      return this.props.required;
    }
    return false;
  }

  getOptions(): any {
    // Protect against undefined (?)
    if (this.props.options) {
      return this.props.options;
    }
    return [];
  }

  getClearable(): boolean {
    if (this.props.clearable) {
      return this.props.clearable;
    }
    return false;
  }

  compareWith(item: any, selected: any) {
    // When using item with ng select2,
    // item structure is: {id: "5", value: "magic_1", label: "Magic 1}
    // selected structure is magic_1 (depending on which key corresponds to ng-select bindValue)
    // Can change the value depending on the this.to.bindValue


    if (this.bindValue === null) {
      return item.id === selected;
    } else {
      return item[this.bindValue] === selected;
    } // if
  }


}
